import { LocalizationProvider as MuiLocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { PropsWithChildren } from "react";
import "dayjs/locale/es";
import dayjs from "dayjs";

//Make dayjs localization spanish
dayjs.locale("es")

export default function LocalizationProvider({
    children
}: PropsWithChildren) {
    return <MuiLocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"es"}>
        {children}
    </MuiLocalizationProvider>
}